const errorInput = {
    errorEmpty: "Customer Number is required",
    errorSpace: "Customer Number must not contain any space",
    errorChar: "CIF must be numbers only",
    errorLength: "Customer Number must be 13 digits"
}

export {
    errorInput
}